<template>
  <AnalyzerTable
    :headers="deviatedEndRateFromMarketTableHeaders"
    get-table-data-action="AnalyzerStore/getDeviatedEndRateFromMarket"
    table-data-getter="AnalyzerStore/deviatedEndRateFromMarket"
  />
</template>

<script>
import AnalyzerTable from "./AnalyzerTable";
import {deviatedEndRateFromMarketTableHeaders} from "@/utils/staticTablesColumns";

export default {
  name: "DeviatedEndRateFromMarket",
  components: {
    AnalyzerTable
  },
  created() {
    this.deviatedEndRateFromMarketTableHeaders = deviatedEndRateFromMarketTableHeaders;
  }
}
</script>

<style scoped>

</style>